import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom'
import { Input, Card, DatePicker, Button, Select} from 'antd';
import store from "./store";
import projectStore from "../../user/project/store";
import Table from './Table';
import Form from './Form'; 
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';


import {observer} from 'mobx-react'; 

import styles from './layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';
import SearchForm, {SearchFormItem} from "../../../components/SearchForm";


export default observer(function (props) {

  const { RangePicker } = DatePicker;

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)
  const typeTxt = [t('自有'), t('采购'), t('租赁')]

  const titleObj = {
    'Sale':'采买设备',
    'Rent':'租赁设备',
    'Store':'仓储设备',
  }

  const [searchType,setSearchType] = useState(false);
  const [searchExpand,setSearchExpand] = useState(false);
  const  history = useHistory();
  useEffect(() => {
    store.page = 1;
    store.pageSize = 10;
    store.pageTotal = 0;
    store.catalog = null; // 设备类型(销售Sale/租赁Rent/仓储Store) 必填
    store.keywords = null; // 关键字搜索(设备名称、货号、PO号)
    store.orgName = null; // 客户名称
    store.projectNo = null; // 项目号
    store.purchaseNo = null; // PO号
    store.productName = null; // 设备名称
    store.factoryCode = null; // 货号
    store.brandName = null; // 品牌
    store.materialCode = null; // 物料编码
    store.deviceSerialNo = null; // 设备序列号
    store.centerNo = null; // 中心号
    store.orderCreatedAt = null; // 订单创建开始时间
    store.name = null; // 联系人
    store.applyUserId = null; // 申请人ID
    store.applyUserName = null; // 申请人名称
    store.storeName = null; // 存放点
    store.certEndDate = null; // 校准结束日期
    store.startDate = null; // 租赁起租日期
    store.endDate = null; // 租赁到期日期
    store.noticeDate = null; // 租赁到期提醒日期
    const path = history.location.pathname;
    const type = path.split('/')[3];
    store.f_type = type;
    store.fetchCheckEndNum();
    store.fetchRecords()
  }, [])

  const handleExport = ()=>{
    store.onExport();
  }
  const handleSearch = ()=>{
    store.fetchRecords();
  }
  const clearSearch = ()=>{
    store.catalog = null;
    store.orgName = null;
    store.projectNo = null;
    store.purchaseNo = null;
    store.productName = null;
    store.factoryCode = null;
    store.brandName = null;
    store.materialCode = null;
    store.deviceSerialNo = null;
    store.centerNo = null;
    store.orderCreatedAt = null;
    store.name = null;
    store.applyUserId = null;
    store.applyUserName = null;
    store.storeName = null;
    store.certEndDate = null;
    store.startDate = null;
    store.endDate = null;
    store.noticeDate = null;
    store.keywords = null;
  }
  const resetSearch = ()=>{
    clearSearch();
    store.fetchRecords();
  }

  const searchCertEndDate = ()=>{
    clearSearch();
    setSearchType(true);
    setTimeout(()=>{
      let startDate = moment().add(1,'M').startOf('month');
      let endDate = moment().add(1,'M').endOf('month');
      store.certEndDate = [startDate,endDate];
      store.fetchRecords()
      setSearchExpand(true);
    },0)
  }
  const searchEndDate = ()=>{
    clearSearch();
    setSearchType(true);
    setTimeout(()=>{
      let startDate = moment().add(1,'M').startOf('month');
      let endDate = moment().add(1,'M').endOf('month');
      store.endDate = [startDate,endDate];
      store.fetchRecords();
      setSearchExpand(true);
    },0)
  }

  // useEffect(() => {
  //   projectStore.records.length === 0 ? projectStore.fetchRecords().then(() => {
  //     store.fetchRecords().then()
  //   }) : store.records.length === 0 && store.fetchRecords().then()
  // }, []);



  return (
    <React.Fragment>
      <div className={[styles.cart, 'rest-nav1'].join(" ")}>

        <div className={styles.listTitle}>
          <span className={styles.title} style={{paddingLeft:'0.0781rem'}}>{t(titleObj[store.f_type])}</span>
          <div className='expire_container' style={{display:store.checkEndNumLoading&&'none'}}>
              下月到期证书<span className='num' onClick={()=>store.certEndNum?searchCertEndDate():''}>&nbsp;{store.certEndNum}&nbsp;</span>张
              <span style={{display:store.f_type!=='Rent'&&'none'}}>
                ,下月到期设备<span className='num' onClick={()=>store.rentEndNum?searchEndDate():''}>&nbsp;{store.rentEndNum}&nbsp;</span>台
              </span></div>
        </div>
        <SearchForm isExport={true} expand={searchExpand} setExpand={setSearchExpand} onExport={handleExport} onFinish={handleSearch} onReset={resetSearch} height='auto'>
            <SearchFormItem span={8} title='PO号'>
              <Input allowClear value={store.purchaseNo} onChange={e => store.purchaseNo = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='项目号'>
              <Input allowClear value={store.projectNo} onChange={e => store.projectNo = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='申请人'>
              <Input allowClear value={store.applyUserName} onChange={e => store.applyUserName = e.target.value} placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='设备名称'>
              <Input allowClear value={store.productName} onChange={e => store.productName = e.target.value}
                  placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='品牌'>
              <Input allowClear value={store.brandName} onChange={e => store.brandName = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='货号'>
              <Input allowClear value={store.factoryCode} onChange={e => store.factoryCode = e.target.value} placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='联系人'>
              <Input allowClear value={store.name} onChange={e => store.name = e.target.value} placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='序列号'>
              <Input allowClear value={store.deviceSerialNo} onChange={e => store.deviceSerialNo = e.target.value} placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='发票抬头'>
              <Input allowClear value={store.invoiceTitle} onChange={e => store.invoiceTitle = e.target.value} placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='下单日期'>
            <RangePicker allowClear style={{width:'1.1979rem'}}  value={store.orderCreatedAt} locale={locale} onChange={e => store.orderCreatedAt = e}/>
            </SearchFormItem>
            <SearchFormItem span={8} title='中心号'>
              <Input allowClear value={store.centerNo} onChange={e => store.centerNo = e.target.value} placeholder="请输入" />
            </SearchFormItem>
            {
              store.f_type==='Store'&&
               <SearchFormItem span={8} title='存放地点'>
                <Input allowClear value={store.storeName} onChange={e => store.storeName = e.target.value} placeholder="请输入" />
              </SearchFormItem>
            }
            <SearchFormItem span={8} title='校准结束日期'>
                <RangePicker allowClear style={{width:'1.1979rem'}}  value={store.certEndDate} locale={locale} onChange={e => store.certEndDate = e}/>
            </SearchFormItem>
            {
              store.f_type==='Rent'&&
              <>
               <SearchFormItem span={8} title='起租日期'>
                <RangePicker allowClear style={{width:'1.1979rem'}}  value={store.startDate} locale={locale} onChange={e => store.startDate = e}/>
              </SearchFormItem>
              <SearchFormItem span={8} title='到期日期'>
                  <RangePicker allowClear style={{width:'1.1979rem'}}  value={store.endDate} locale={locale} onChange={e => store.endDate = e}/>
              </SearchFormItem>
              {/* <SearchFormItem span={8} title='租赁到期日期'>
                  <RangePicker allowClear value={store.noticeDate} locale={locale} onChange={e => store.noticeDate = e}/>
              </SearchFormItem> */}
              </>
            }
        </SearchForm>

        <div className="mainBox">
        <Table/>
        </div>
        {store.formVisible && <Form/>}
      </div>

    </React.Fragment>
  )

})
